<template>
    <form>
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-9">
                        <!-- <h4 class="card-title font-weight-bold">{{$t('medium_grant_ev.technical__evaluation_form')}}</h4> -->
                        <table
                            class="table-bordered table-full-width"
                            cellpadding="20"
                        >
                            <tr>
                                <td>
                                    {{
                                        $t(
                                            "small_technical_grants_ev.technical__assessment_total"
                                        )
                                    }}
                                </td>
                                <td
                                    class="text-center"
                                    style="min-width: 200px"
                                >
                                    <div class="form-group mb-0">
                                        <label for="final_result_score">{{
                                            $t(
                                                "small_technical_grants_ev.technical__final_score"
                                            )
                                        }}</label>
                                        <base-input
                                            type="text"
                                            name="final_result_score"
                                            v-model="
                                                EvaluationForm.model.final_score
                                            "
                                        >
                                        </base-input>
                                        <small>{{
                                            $t(
                                                "small_technical_grants_assessments_ev.technical__final_score_from_info"
                                            )
                                        }}</small>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    {{
                                        $t(
                                            "rapid_response_grant_ev.technical__grid_download"
                                        )
                                    }}
                                </td>
                                <td
                                    class="text-center"
                                    style="min-width: 200px"
                                >
                                    <a
                                        :href="downloadFiles[0][$i18n.locale]"
                                        class="ml-2 btn btn-simple btn-primary"
                                    >
                                        {{
                                            $t(
                                                "small_technical_grants.document_upload__download_template_button_title"
                                            )
                                        }}
                                        <i
                                            class="tim-icons icon-cloud-download-93 ml-2"
                                        ></i>
                                    </a>
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {{
                                        $t(
                                            "small_technical_grants_ev.technical__grid_upload"
                                        )
                                    }}
                                </th>
                                <th
                                    class="text-center"
                                    style="min-width: 200px"
                                >
                                    <upload-file
                                        v-model="
                                            EvaluationForm.files.technical
                                                .stg_technical_grid_upload
                                        "
                                        :select-text="
                                            $t(
                                                'medium_grant_ev.esmsc__upload_pdf'
                                            )
                                        "
                                        :is-evaluation="true"
                                        :file-data="
                                            EvaluationForm.files.technical
                                                .stg_technical_grid_upload
                                        "
                                        :is-editable="EvaluationForm.isEditable"
                                        :size-limit="EvaluationForm.fileSizeLimit"
                                        section="technical.stg_technical_grid_upload"
                                    ></upload-file>
                                </th>
                            </tr>
                        </table>
                    </div>
                    <div class="col-lg-3">
                        <info-right></info-right>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import { EvaluationForm } from "@/services";
import InfoRight from "./InfoRight";
import ApplicationInfo from "../ApplicationInfo";
import { CommentBox } from "src/components";
import { Select, Option } from "element-ui";

export default {
    components: {
        ApplicationInfo,
        InfoRight,
        CommentBox,
        [Select.name]: Select,
        [Option.name]: Option
    },
    data() {
        return {
            EvaluationForm,
            downloadFiles: [
                {
                    en:
                        "/files/en/STGA/Annex_5_Smal_Technical_Grant_for_Assessment_Evaluation_Grid.docx",
                    fr:
                        "/files/en/STGA/Annex_5_Smal_Technical_Grant_for_Assessment_Evaluation_Grid.docx"
                }
            ]
        };
    },
    beforeCreate() {
        if (!EvaluationForm.files.technical) {
            EvaluationForm.files.technical = {};
        }
    },
    methods: {
        getError(fieldName) {
            return this.errors.first(fieldName);
        },
        validate() {
            return this.$validator.validateAll().then(res => {
                this.$emit("on-validated", res, this.model);
                return res;
            });
        }
    }
};
</script>
<style scoped>
textarea {
    resize: vertical !important;
}
</style>
